import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";
import { GameProjection } from "./game";

const VIEW_GAME_BY_CUSTOMER_ID = "view_game_BY_CUSTOMER_ID_by_customer_id";

interface ViewGameByCustomerIdPayload {
  readonly customerId: string;
}

interface ViewGameByCustomerId extends Query<typeof VIEW_GAME_BY_CUSTOMER_ID>, ViewGameByCustomerIdPayload {}

interface ViewGameByCustomerIdFunction {
  (payload: ViewGameByCustomerIdPayload): ViewGameByCustomerId;
}

const viewGameByCustomerId: ViewGameByCustomerIdFunction = (payload) => ({
  ...query({ name: VIEW_GAME_BY_CUSTOMER_ID }),
  ...payload,
});

type ViewGameByCustomerIdResult = GameProjection | null;

interface GameByCustomerIdViewArgs extends CancelableQueryViewArgs {
  readonly customerId: string;
}

interface GameByCustomerIdView {
  (args: GameByCustomerIdViewArgs): Promise<ViewGameByCustomerIdResult>;
}

interface ViewGameByCustomerIdHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: GameByCustomerIdView;
}

const viewGameByCustomerIdHandler: QueryHandlerFunction<
  ViewGameByCustomerId,
  ViewGameByCustomerIdResult,
  ViewGameByCustomerIdHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async ({ customerId }) =>
    view({ customerId, signal });

export type { ViewGameByCustomerId, GameByCustomerIdView, ViewGameByCustomerIdResult };
export { VIEW_GAME_BY_CUSTOMER_ID, viewGameByCustomerId, viewGameByCustomerIdHandler };
